import { Tag } from 'antd';
import moment from 'moment';
import dayjs from 'dayjs';
import { connect } from 'react-redux';
import React, { Fragment, useState, useEffect, useRef } from 'react';
import { config } from '../../constant';
import { arrayOfObjects } from '../../../Mock/MockJson';
import { ErrorComponent, NoRecordComponent } from '../../Utils';
import { getChartDataWithoutSelection, getChartDataWithSelection } from '../../ChartCalls';

const Counter = (props) => {
  const [counter, setCounter] = useState(0);
  const [refreshDateTime, setRefreshDateTime] = useState(dayjs());
  const [errorInAPI, setErrorInAPI] = useState(false);
  const [noDataInDB, setNoDataInDB] = useState(false);
  const [imageData, setImageData] = useState({});
  const boolean = useState(true);
  let timeTicket = useRef(null);
  const requestCheck = useRef(true);
  const abortController = useRef(new window.AbortController());

  const {
    graphprops,
    selectionDate,
    selectionMonth,
    DeviceCode,
    selectionDateRange,
    dayMonthYear,
    currentTimeZone,
    translationCache
  } = props;

  useEffect(() => {
    if (timeTicket.current) {
      clearInterval(timeTicket.current);
    }
    let refreshTime = graphprops?.refreshTime ? graphprops.refreshTime * 60000 : config.defaultRefreshTime;
    timeTicket.current = setInterval(() => {
      if (requestCheck.current) {
        getData();
      }
    }, refreshTime);
    return () => {
      abortController.current.abort();
      clearInterval(timeTicket.current);
    };
  }, []);

  useEffect(() => {
    getData();
  }, [
    selectionDate,
    selectionMonth,
    selectionDateRange,
    DeviceCode,
    dayMonthYear,
    translationCache
  ]);

  const getData = async () => {
    requestCheck.current = false;
    let json = [];
    let errorInAPI = false;
    let noDataInDB = false;

    if (graphprops && graphprops.enableMock && graphprops.enableMock === true) {
      json = arrayOfObjects;
      requestCheck.current = true;
    } else {
      if (graphprops?.graph === 'rangeBar' && graphprops?.currentDateData !== undefined) {
        json = graphprops.currentDateData;
      } else {
        if (
          graphprops &&
          ((graphprops.DashboardLevelSelection === 'datePicker' ||
            graphprops.GraphLevelSelection === 'datePicker') &&
            selectionDate) ||
          (
            (graphprops.DashboardLevelSelection === 'monthPicker' ||
              graphprops.GraphLevelSelection === 'monthPicker') &&
            selectionMonth) ||
          (
            (graphprops.DashboardLevelSelection === 'dateRangePicker' ||
              graphprops.GraphLevelSelection === 'dateRangePicker') &&
            selectionDateRange) ||
          (
            (graphprops.DashboardLevelSelection === 'dateMonthYearPicker' ||
              graphprops.GraphLevelSelection === 'dateMonthYearPicker') &&
            dayMonthYear) ||
          (
            (graphprops.DashboardLevelSelection === 'deviceSelection' ||
              graphprops.GraphLevelSelection === 'deviceSelection') &&
            DeviceCode)
        ) {
          json = await getChartDataWithSelection({
            graphprops,
            selectionDate,
            selectionMonth,
            selectionDateRange,
            DeviceCode,
            dayMonthYear,
            abortController: abortController.current,
            currentTimeZone,
          });
          requestCheck.current = true;
        } else if (
          graphprops.GraphLevelSelection === 'none' ||
          graphprops.DashboardLevelSelection === 'none'
        ) {
          json = await getChartDataWithoutSelection({
            graphprops,
            abortController: abortController.current,
            DeviceCode,
            TimeZone: currentTimeZone,
          });
          requestCheck.current = true;
        }
      }
    }
    if (
      (json && json.message) ||
      (Array.isArray(json) && json.length === 0 && props.graphprops.enableMock !== true)
    ) {
      if (json.message) {
        errorInAPI = true;
      } else if (json.length === 0) {
        noDataInDB = true;
      }
    } else {
      if (
        json &&
        Array.isArray(json) &&
        json.length > 0 &&
        props.graphprops[props.graphprops.graph] &&
        props.graphprops[props.graphprops.graph].counterType === 'number'
      ) {
        setCounter(Number(json[0].Value).toFixed(2));
      } else if (
        json &&
        Array.isArray(json) &&
        json.length > 0 &&
        props.graphprops[props.graphprops.graph] &&
        props.graphprops[props.graphprops.graph].counterType === 'string'
      ) {
        setCounter(json[0].Value);
        setRefreshDateTime(moment());
      } else if (
        json &&
        Array.isArray(json) &&
        json.length > 0 &&
        props.graphprops &&
        props.graphprops[props.graphprops.graph] &&
        props.graphprops[props.graphprops.graph].counterType === 'both'
      ) {
        setCounter(Number(json[0].Value).toFixed(2));
      } else if (
        json &&
        Array.isArray(json) &&
        json.length > 0 &&
        props.graphprops[props.graphprops.graph] &&
        props.graphprops[props.graphprops.graph].counterType === 'boolean'
      ) {
        setCounter(Number(json[0].Value).toFixed(2), boolean(true));
      } else if (
        json &&
        Array.isArray(json) &&
        json.length > 0 &&
        props.graphprops[props.graphprops.graph] &&
        props.graphprops[props.graphprops.graph].counterType === 'date-picker'
      ) {
        let value = null;

        try {
          if (Array.isArray(json) && json.length > 0 && json[0].DateTime !== undefined) {
            value = moment.utc(json[0].DateTime).tz(props.currentTimeZone).format('YYYY-MM-DD HH:mm');
          }
        } catch (error) {
          console.error("An error occurred:");
        }
        setCounter(value);
      }
      if (
        props.graphprops &&
        props.graphprops[props.graphprops.graph] &&
        props.graphprops[props.graphprops.graph].displayType &&
        props.graphprops[props.graphprops.graph].displayType === 'Image & Value'
      ) {
        setImageData(json && json[0] ? json[0] : {});
      }
      setErrorInAPI(errorInAPI);
      setNoDataInDB(noDataInDB);
    }
    if (json && Array.isArray(json) && json[0] && json[0].Value === null) {
      setErrorInAPI(errorInAPI);
      setNoDataInDB(!noDataInDB);
    } else {
      setErrorInAPI(errorInAPI);
      setNoDataInDB(noDataInDB);
    }
  };

  return (
    <Fragment>
      {props.graphprops && props.graphprops.checked === true ? (
        <Tag className="graphTag" color="blue">
          {refreshDateTime ? moment(refreshDateTime).format('YYYY-MM-DD HH:mm:ss') : ''}
        </Tag>
      ) : null}
      {noDataInDB === true || errorInAPI === true ? (
        noDataInDB === true ? (
          <NoRecordComponent />
        ) : (
          <ErrorComponent />
        )
      ) : boolean === true ? (
        <div
          style={{
            textAlign: 'center'
          }}
        >
          <span
            style={{
              color: counter === 'on' ? 'green' : 'red',
              fontSize: props.graphprops.counter.fontSize
                ? props.graphprops.counter.fontSize + 'em'
                : '5em'
            }}
          >
            {counter}
          </span>
        </div>
      ) : (
        <div
          style={{
            textAlign: 'center',
            display: 'flex',
            justifyContent: 'space-around',
            flexWrap: `wrap`
          }}
        >
          {props.graphprops &&
            props.graphprops[props.graphprops.graph] &&
            props.graphprops[props.graphprops.graph].displayType &&
            props.graphprops[props.graphprops.graph].displayType === 'Image & Value' ? (
            <span
              style={{
                justifyContent: 'center',
                width: '50%',
                alignItems: 'center'
              }}
            >
              <img
                src={imageData && imageData.Description ? imageData.Description : ''}
                type="image"
                alt=""
                style={{ height: '100px', width: '110px' }}
              />
            </span>
          ) : null}

          <span
            style={{
              color:
                props.graphprops[props.graphprops.graph] &&
                  props.graphprops[props.graphprops.graph].titleColor
                  ? props.graphprops[props.graphprops.graph].titleColor
                  : '',
              fontSize:
                props.graphprops[props.graphprops.graph] &&
                  props.graphprops[props.graphprops.graph].fontSize
                  ? props.graphprops[props.graphprops.graph].fontSize + 'em'
                  : '5em',
              justifyContent: 'center',
              width: '50%',
              alignItems: 'center',
              marginTop: '5%'
            }}
          >
            {counter}
          </span>
        </div>
      )}
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
     theme: state.ThemeReducer,
    translationCache: state.TranslationReducer.translationCache,
    currentTimeZone: state.LayoutReducer.currentTimeZone,
  };
};

export default connect(mapStateToProps)(Counter);